import React, { useEffect, useState } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import { Link } from 'react-router-dom'
import { appAddress } from '../../../../App'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { dispatchGetAllUsers, fetchAllUsers } from '../../../../redux/actions/usersAction'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserTie, faTrashCan } from '@fortawesome/free-solid-svg-icons'
import DashNavbar from '../navbar/Navbar'
import DashMenu from '../menu/DashMenu'
import DashFooter from '../footer/DashFooter'
import i18n from '../../../../i18n'
import { useTranslation } from 'react-i18next'


const initialState = {
    name: '',
    password: '',
    cf_password: '',
    err: '',
    success: ''
}

export default function Users() {
    const {t} = useTranslation()


    const auth = useSelector(state => state.auth)
    const token = useSelector(state => state.token)

    const users = useSelector(state => state.users)

    const {user, isAdmin} = auth
    const [data, setData] = useState(initialState)
    // const {name, password, cf_password } = data

    const [callback, setCallback] = useState(false)

    const dispatch = useDispatch()

    useEffect(() => {
        const savedLanguage = localStorage.getItem('language') || 'en';
        i18n.changeLanguage(savedLanguage);
    
        const rootElement = document.getElementById('root');
        if (savedLanguage === 'fa' || savedLanguage === 'ar') {
          rootElement.classList.remove('ltr', 'text-left');
          rootElement.classList.add('rtl', 'text-right');
        } else {
          rootElement.classList.remove('rtl', 'text-right');
          rootElement.classList.add('ltr', 'text-left');
        }
      }, []);

    useEffect(() => {
        if(isAdmin){
            fetchAllUsers(token).then(res =>{
                dispatch(dispatchGetAllUsers(res))
            })
        }
    },[token, isAdmin, dispatch, callback])


const handleDelete  = async(id) => {
    try {
        if(user._id !== id){
            if(window.confirm("are you sure?")){
                await axios.delete(`${appAddress}/user/delete/${id}`,{
                // await axios.delete(`/user/delete/${id}`,{
                    headers: {Authorization: token}
                })
                setCallback(!callback)
            }
        }
    } catch (err) {
        setData({
            ...data,
              err: toast.error(err.response.data.msg, {
        position:"bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        })
           , success: ''
        })
    }
}

    return (
        <div className='bg-[#2a3447] text-teal-50 ltr'>
          <ToastContainer
                  position="bottom-right"
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop
                  closeOnClick
                  rtl
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover/>
          <DashNavbar />
          <div className='flex'>
            <div className='w-[250px] p-5 border-r-4 mt-14'>
              <DashMenu />
            </div>
            <div className='p-4 w-[100%] mt-5'>
              <div className=' w-[100%] flex flex-col justify-center items-center gap-5'>      
                <h2 className='font-englishTitle text-2xl'>{t("userList")}</h2>
                <hr className='bg-slate-500 w-[20%] mb-3' />
                <div className='w-[90%] flex'>
                    <table className='w-[100%] border-collapse border border-slate-500 table-auto'>
                        <thead>
                            <tr className='text-center text-amber-500 text-md'>
                                <th className='font-englishTitle border border-slate-600'>{t("userName")}</th>
                                <th className='font-englishTitle border border-slate-600'>{t("fullName")}</th>
                                <th className='font-englishTitle border border-slate-600'>{t("Email")}</th>
                                <th className='font-englishTitle border border-slate-600'>{t("Role")}</th>
                                <th className='font-englishTitle border border-slate-600'>{t("Promotion")}</th>
                                <th className='font-englishTitle border border-slate-600'>{t("Delete")}</th>
                            </tr>
                        </thead>
                        <tbody className=''>
                            {
                                users.map((user =>(
                                    <tr key={user._id} className='text-center '>
                                        <td className='font-english border border-slate-700 '>{user.userName}</td>
                                        <td className='font-english border border-slate-700'>{user.name}</td>
                                        <td className='font-english border border-slate-700'>{user.email}</td>
                                        <td className='font-english border border-slate-700'>
                                            {
                                                user.role === 1 ? <i className="fas fa-check" title={"admin title"}>Admin</i>
                                                : <i className="fas fa-times" title={"email"}>User</i>
                                            }
                                        </td>
                                        <td className='border border-slate-700'>
                                            <Link to={`${appAddress}/edit_user/${user._id}`}>
                                            {/* <Link to={`/edit_user/${user._id}`}> */}
                                            <i className="m-4 fas fa-edit text-lime-500" title="Edit">
                                            <FontAwesomeIcon icon={faUserTie} />
                                            </i>
                                            </Link>
                                        </td>
                                        <td className='border border-slate-700'>
                                            <i className="m-4 text-red-600 fas fa-trash-alt" title="Delete"
                                            onClick={() => handleDelete(user._id)} >
                                                <FontAwesomeIcon icon={faTrashCan} />
                                            </i>
                                        </td>
                                    </tr>
                                )))
                            }
                        </tbody>
                    </table>
                </div>
               </div> 
    
            </div>
          </div>
          <div className='mt-16'>
            <DashFooter />
            </div>
        </div>
    )    
}
